(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function money(cents, currency) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: currency || 'COP',
        maximumFractionDigits: 0
      }).format(value);
    } catch (err) {
      return '$' + Math.round(value).toLocaleString('es-CO');
    }
  }

  function cuota(cents, months, rate) {
    if (!months) return cents;
    if (!rate) return Math.round(cents / months);
    var factor = Math.pow(1 + rate, months);
    return Math.round((cents * (rate * factor)) / (factor - 1));
  }

  function copyToClipboard(text) {
    var fallback = function () {
      return new Promise(function (resolve, reject) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '0';
        ta.style.left = '0';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try {
          var ok = document.execCommand('copy');
          document.body.removeChild(ta);
          if (ok) resolve();
          else reject(new Error('copy failed'));
        } catch (err) {
          document.body.removeChild(ta);
          reject(err);
        }
      });
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () {
        return fallback();
      });
    }
    return fallback();
  }

  function WgGallery(root) {
    this.root = root;
    this.slides = qsa(root, '[data-wg-slide]');
    this.thumbs = qsa(root, '[data-wg-thumb]');
    this.viewport = qs(root, '[data-wg-gallery-viewport]');
    this.track = qs(root, '.wg-pdp-gallery__track');
    this.counter = qs(root, '[data-wg-gallery-counter]');
    this.thumbsWrap = qs(root, '[data-wg-thumbs]');
    this.prevBtn = qs(root, '[data-wg-thumbs-prev]');
    this.nextBtn = qs(root, '[data-wg-thumbs-next]');
    this.lightbox = document.querySelector('[data-wg-lightbox]');
    this.zoomEnabled = root.getAttribute('data-zoom') !== 'false';
    this.index = parseInt(root.getAttribute('data-index') || '0', 10) || 0;
    this.mq = window.matchMedia('(max-width: 989px)');
    this.lastFocus = null;
    this.bind();
    this.go(this.index, true);
    this.updateThumbOverflow();
  }

  WgGallery.prototype.bind = function () {
    var self = this;
    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        self.go(parseInt(thumb.getAttribute('data-index'), 10));
      });
      thumb.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          self.go(self.index + 1);
          self.focusThumb();
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          self.go(self.index - 1);
          self.focusThumb();
        }
      });
    });

    if (this.track) {
      this.track.addEventListener(
        'scroll',
        function () {
          if (!self.mq.matches) return;
          self.syncFromScroll();
        },
        { passive: true }
      );
    }

    qsa(this.root, '[data-wg-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var slide = btn.closest('[data-wg-slide]');
        var idx = slide ? parseInt(slide.getAttribute('data-index'), 10) : self.index;
        self.openLightbox(idx);
      });
    });

    this.slides.forEach(function (slide) {
      slide.addEventListener('click', function (event) {
        if (self.isMobile()) return;
        if (event.target.closest('[data-wg-zoom]')) return;
        if (slide.getAttribute('data-media-type') !== 'image') return;
        if (!self.zoomEnabled) return;
        self.openLightbox(parseInt(slide.getAttribute('data-index'), 10));
      });
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.thumbsWrap.scrollBy({ top: -80, behavior: 'smooth' });
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.thumbsWrap.scrollBy({ top: 80, behavior: 'smooth' });
      });
    }
    if (this.thumbsWrap) {
      this.thumbsWrap.addEventListener('scroll', function () {
        self.updateThumbOverflow();
      });
      window.addEventListener('resize', function () {
        self.updateThumbOverflow();
      });
    }

    if (this.lightbox) {
      qsa(this.lightbox, '[data-wg-lightbox-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.closeLightbox();
        });
      });
      var prev = qs(this.lightbox, '[data-wg-lightbox-prev]');
      var next = qs(this.lightbox, '[data-wg-lightbox-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); self.renderLightbox(); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); self.renderLightbox(); });
      this.lightbox.addEventListener('keydown', function (event) {
        self.onLightboxKey(event);
      });
      this.bindLightboxSwipe();
    }
  };

  WgGallery.prototype.isMobile = function () {
    return this.mq.matches;
  };

  WgGallery.prototype.go = function (index, instant) {
    if (!this.slides.length) return;
    var total = this.slides.length;
    this.index = ((index % total) + total) % total;
    var self = this;
    this.slides.forEach(function (slide, i) {
      var on = i === self.index;
      slide.classList.toggle('is-active', on);
      slide.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    this.thumbs.forEach(function (thumb, i) {
      var on = i === self.index;
      thumb.classList.toggle('is-active', on);
      thumb.setAttribute('aria-selected', on ? 'true' : 'false');
      thumb.tabIndex = on ? 0 : -1;
    });
    if (this.counter) {
      this.counter.textContent = this.index + 1 + ' / ' + total;
    }
    this.root.setAttribute('data-index', String(this.index));
    if (this.isMobile() && this.slides[this.index] && this.track) {
      this.slides[this.index].scrollIntoView({
        behavior: instant ? 'auto' : 'smooth',
        inline: 'start',
        block: 'nearest'
      });
    }
    if (this.thumbs[this.index] && this.thumbsWrap && !this.isMobile()) {
      this.thumbs[this.index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  };

  WgGallery.prototype.goToMedia = function (mediaId) {
    if (!mediaId) return;
    var idx = this.slides.findIndex(function (slide) {
      return slide.getAttribute('data-media-id') === String(mediaId);
    });
    if (idx >= 0) this.go(idx);
  };

  WgGallery.prototype.syncFromScroll = function () {
    if (!this.track || !this.slides.length) return;
    var left = this.track.scrollLeft;
    var width = this.slides[0].getBoundingClientRect().width || 1;
    var idx = Math.round(left / width);
    if (idx !== this.index) this.go(idx, true);
  };

  WgGallery.prototype.focusThumb = function () {
    if (this.thumbs[this.index]) this.thumbs[this.index].focus();
  };

  WgGallery.prototype.updateThumbOverflow = function () {
    if (!this.thumbsWrap || !this.prevBtn || !this.nextBtn || this.isMobile()) return;
    var overflow = this.thumbsWrap.scrollHeight > this.thumbsWrap.clientHeight + 8;
    this.prevBtn.classList.toggle('is-visible', overflow);
    this.nextBtn.classList.toggle('is-visible', overflow);
    this.prevBtn.hidden = !overflow;
    this.nextBtn.hidden = !overflow;
  };

  WgGallery.prototype.openLightbox = function (index) {
    if (!this.lightbox || !this.zoomEnabled) return;
    this.lastFocus = document.activeElement;
    this.go(index);
    this.renderLightbox();
    this.lightbox.hidden = false;
    var dialog = qs(this.lightbox, '.wg-pdp-lightbox__dialog');
    if (dialog) dialog.focus();
    document.body.style.overflow = 'hidden';
  };

  WgGallery.prototype.closeLightbox = function () {
    if (!this.lightbox) return;
    this.lightbox.hidden = true;
    document.body.style.overflow = '';
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  WgGallery.prototype.renderLightbox = function () {
    var slide = this.slides[this.index];
    var img = qs(this.lightbox, '[data-wg-lightbox-img]');
    var cap = qs(this.lightbox, '[data-wg-lightbox-cap]');
    if (!slide || !img) return;
    var src = slide.getAttribute('data-zoom-src');
    var altImg = slide.querySelector('img');
    img.src = src || (altImg ? altImg.currentSrc || altImg.src : '');
    img.alt = altImg ? altImg.alt : '';
    if (cap) cap.textContent = this.index + 1 + ' / ' + this.slides.length;
  };

  WgGallery.prototype.onLightboxKey = function (event) {
    if (this.lightbox.hidden) return;
    if (event.key === 'Escape') this.closeLightbox();
    if (event.key === 'ArrowLeft') {
      this.go(this.index - 1);
      this.renderLightbox();
    }
    if (event.key === 'ArrowRight') {
      this.go(this.index + 1);
      this.renderLightbox();
    }
    if (event.key === 'Tab') this.trapFocus(event);
  };

  WgGallery.prototype.trapFocus = function (event) {
    var focusable = qsa(
      this.lightbox,
      'button:not([hidden]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    ).filter(function (el) {
      return !el.hasAttribute('hidden') && el.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  WgGallery.prototype.bindLightboxSwipe = function () {
    var self = this;
    var startX = 0;
    var figure = qs(this.lightbox, '.wg-pdp-lightbox__figure');
    if (!figure) return;
    figure.addEventListener(
      'touchstart',
      function (event) {
        startX = event.changedTouches[0].screenX;
      },
      { passive: true }
    );
    figure.addEventListener(
      'touchend',
      function (event) {
        var dx = event.changedTouches[0].screenX - startX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) self.go(self.index + 1);
        else self.go(self.index - 1);
        self.renderLightbox();
      },
      { passive: true }
    );
  };

  function WgPdp(root) {
    this.root = root;
    this.currency = root.getAttribute('data-currency') || 'COP';
    this.gallery = qs(root, '[data-wg-gallery]') ? new WgGallery(qs(root, '[data-wg-gallery]')) : null;
    this.jsonEl = qs(root, '[data-wg-product-json]');
    this.data = this.jsonEl ? JSON.parse(this.jsonEl.textContent) : { variants: [] };
    this.form = qs(root, '.wg-pdp-form');
    this.idInput = qs(root, '[data-wg-variant-id]');
    this.optionInputs = qsa(root, '[data-wg-option]');
    this.atc = qsa(root, '[data-wg-atc], [data-wg-sticky-submit]');
    this.qtyInput = qs(root, '[data-wg-qty-input]');
    this.sticky = qs(root, '[data-wg-sticky-atc]');
    this.atcWrap = qs(root, '[data-wg-atc-wrap]');
    this.bind();
    this.syncFromChecked();
    this.bindSticky();
    this.bindRefCopy();
    this.bindDescMore();
    this.updateFinancing(this.currentVariant());
  }

  WgPdp.prototype.bind = function () {
    var self = this;
    this.optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        self.onOptionChange();
      });
    });
    qsa(this.root, '[data-wg-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.stepQty(-1);
      });
    });
    qsa(this.root, '[data-wg-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.stepQty(1);
      });
    });
    if (this.qtyInput) {
      this.qtyInput.addEventListener('change', function () {
        self.clampQty();
      });
    }
  };

  WgPdp.prototype.selectedOptions = function () {
    var values = [];
    this.optionInputs.forEach(function (input) {
      if (!input.checked) return;
      values[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
    });
    return values;
  };

  WgPdp.prototype.findVariant = function (options, requireAvailable) {
    var variants = this.data.variants || [];
    return variants.find(function (variant) {
      if (requireAvailable && !variant.available) return false;
      return variant.options.every(function (opt, i) {
        return !options[i] || opt === options[i];
      });
    });
  };

  WgPdp.prototype.currentVariant = function () {
    if (this.idInput) {
      var id = parseInt(this.idInput.value, 10);
      return (this.data.variants || []).find(function (variant) {
        return variant.id === id;
      }) || this.data.variants[0];
    }
    return this.data.variants[0];
  };

  WgPdp.prototype.onOptionChange = function () {
    var selected = this.selectedOptions();
    var variant = this.findVariant(selected, true) || this.findVariant(selected, false);
    if (!variant) return;
    this.applyVariant(variant);
  };

  WgPdp.prototype.applyVariant = function (variant) {
    if (!variant) return;
    if (this.idInput) this.idInput.value = variant.id;
    if (!window.Shopify || !Shopify.designMode) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        history.replaceState({}, '', url.toString());
      } catch (err) {}
    }
    this.updatePrice(variant);
    this.updateAvailability(variant);
    this.updateQtyMax(variant);
    this.updateOptionAvailability(variant);
    this.updateFinancing(variant);
    this.updateFreeShip(variant);
    if (this.gallery && variant.featured_media_id) {
      this.gallery.goToMedia(variant.featured_media_id);
    }
    this.root.dispatchEvent(
      new CustomEvent('wg:variant:change', { bubbles: true, detail: { variant: variant } })
    );
  };

  WgPdp.prototype.syncFromChecked = function () {
    var variant = this.currentVariant();
    if (variant) this.updateOptionAvailability(variant);
  };

  WgPdp.prototype.updatePrice = function (variant) {
    var wrap = qs(this.root, '[data-wg-price-wrap]');
    if (!wrap) return;
    var priceEl = qs(wrap, '[data-wg-price]');
    var compareEl = qs(wrap, '[data-wg-compare]');
    var percentEl = qs(wrap, '[data-wg-percent]');
    var saveEl = qs(wrap, '[data-wg-save]');
    var stickyPrice = qs(this.root, '[data-wg-sticky-price]');
    if (priceEl) priceEl.textContent = money(variant.price, this.currency);
    if (stickyPrice) stickyPrice.textContent = money(variant.price, this.currency);
    var onSale = variant.compare_at_price > variant.price;
    wrap.classList.toggle('wg-pdp-price--sale', onSale);
    if (compareEl) {
      compareEl.hidden = !onSale;
      if (onSale) compareEl.textContent = money(variant.compare_at_price, this.currency);
    }
    if (percentEl) {
      if (onSale && variant.compare_at_price) {
        var pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        percentEl.hidden = pct <= 0;
        percentEl.textContent = '-' + pct + '%';
      } else {
        percentEl.hidden = true;
      }
    }
    if (saveEl) {
      if (onSale) {
        saveEl.hidden = false;
        saveEl.textContent = 'Ahorras ' + money(variant.compare_at_price - variant.price, this.currency);
      } else {
        saveEl.hidden = true;
      }
    }
  };

  WgPdp.prototype.updateAvailability = function (variant) {
    var sold = !variant.available;
    this.atc.forEach(function (btn) {
      btn.disabled = sold;
      var add = btn.getAttribute('data-label-add');
      var soldLabel = btn.getAttribute('data-label-sold');
      var labelEl = btn.querySelector('[data-wg-atc-label]');
      var next = sold ? soldLabel : add;
      if (next) {
        if (labelEl) labelEl.textContent = next;
        else btn.textContent = next;
      }
    });
  };

  WgPdp.prototype.updateQtyMax = function (variant) {
    if (!this.qtyInput) return;
    var max = 99;
    if (variant.inventory_management && variant.inventory_policy !== 'continue') {
      max = Math.max(1, variant.inventory_quantity || 1);
    }
    this.qtyInput.max = String(max);
    this.clampQty();
  };

  WgPdp.prototype.stepQty = function (delta) {
    if (!this.qtyInput) return;
    var next = (parseInt(this.qtyInput.value, 10) || 1) + delta;
    this.qtyInput.value = String(next);
    this.clampQty();
  };

  WgPdp.prototype.clampQty = function () {
    if (!this.qtyInput) return;
    var min = parseInt(this.qtyInput.min || '1', 10);
    var max = parseInt(this.qtyInput.max || '99', 10);
    var val = parseInt(this.qtyInput.value, 10) || min;
    if (val < min) val = min;
    if (val > max) val = max;
    this.qtyInput.value = String(val);
  };

  WgPdp.prototype.updateOptionAvailability = function (selectedVariant) {
    var self = this;
    var selected = selectedVariant ? selectedVariant.options.slice() : this.selectedOptions();
    var variants = this.data.variants || [];
    this.optionInputs.forEach(function (input) {
      var optionIndex = parseInt(input.getAttribute('data-option-index'), 10);
      var value = input.value;
      var exists = variants.some(function (variant) {
        if (variant.options[optionIndex] !== value) return false;
        return selected.every(function (sel, i) {
          if (i === optionIndex) return true;
          return !sel || variant.options[i] === sel;
        });
      });
      var purchasable = variants.some(function (variant) {
        if (!variant.available) return false;
        if (variant.options[optionIndex] !== value) return false;
        return selected.every(function (sel, i) {
          if (i === optionIndex) return true;
          return !sel || variant.options[i] === sel;
        });
      });
      var pill = input.nextElementSibling;
      input.disabled = !exists;
      if (pill) pill.classList.toggle('is-unavailable', !purchasable);
    });
    qsa(this.root, '[data-wg-option-label]').forEach(function (label) {
      var idx = parseInt(label.getAttribute('data-wg-option-label'), 10);
      if (selected[idx]) label.textContent = selected[idx];
    });
  };

  WgPdp.prototype.updateFinancing = function (variant) {
    var self = this;
    var boxes = qsa(document, '[data-wg-financing]');
    if (!boxes.length || !variant) return;
    boxes.forEach(function (box) {
      var from = qs(box, '[data-wg-financing-from]');
      var rate = parseFloat(box.getAttribute('data-int-addi') || '0');
      var monthly = cuota(variant.price, 6, rate);
      if (!from) return;
      if (monthly && monthly > 0) {
        var tpl = box.getAttribute('data-from-template') || 'Desde __AMT__ / mes';
        from.hidden = false;
        from.textContent = tpl.replace('__AMT__', money(monthly, self.currency));
      } else {
        from.hidden = true;
        from.textContent = '';
      }
    });
  };

  WgPdp.prototype.updateFreeShip = function (variant) {
    var el = qs(this.root, '[data-wg-free-ship]');
    if (!el || !variant) return;
    var threshold = parseInt(el.getAttribute('data-threshold') || '0', 10);
    if (!threshold) return;
    if (variant.price >= threshold) {
      var label = el.querySelector('span:last-child');
      var copy = el.getAttribute('data-label-free') || 'Envío gratis a todo Colombia';
      if (label) label.textContent = copy;
      else el.textContent = copy;
    }
  };

  WgPdp.prototype.bindRefCopy = function () {
    var self = this;
    qsa(this.root, '[data-wg-copy-ref]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.copyRef(btn);
      });
    });
  };

  WgPdp.prototype.copyRef = function (btn) {
    var text = btn.getAttribute('data-copy') || '';
    if (!text) return;
    var feedback = qs(btn, '[data-wg-copy-feedback]');
    var label = btn.getAttribute('data-copied-label') || 'Copiado';
    copyToClipboard(text)
      .then(function () {
        btn.classList.add('is-copied');
        if (feedback) feedback.textContent = label;
        window.setTimeout(function () {
          btn.classList.remove('is-copied');
          if (feedback) feedback.textContent = '';
        }, 1600);
      })
      .catch(function () {});
  };

  WgPdp.prototype.bindDescMore = function () {
    var wrap = qs(this.root, '[data-wg-desc-clip]');
    var btn = qs(this.root, '[data-wg-desc-more]');
    var rte = wrap ? qs(wrap, '[data-wg-desc-rte]') : null;
    if (!wrap || !btn || !rte) return;
    var limit = 240;
    if (rte.scrollHeight <= limit + 48) {
      btn.hidden = true;
      return;
    }
    wrap.classList.add('is-clipped');
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-open');
      wrap.classList.toggle('is-clipped', !open);
      var more = btn.getAttribute('data-label-more') || '';
      var less = btn.getAttribute('data-label-less') || '';
      btn.textContent = open ? less : more;
    });
  };

  WgPdp.prototype.bindSticky = function () {
    var self = this;
    if (!this.sticky || !this.atcWrap) return;
    if (this.root.getAttribute('data-sticky-atc') === 'false') return;
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var show = entry && !entry.isIntersecting;
        self.sticky.hidden = !show;
      },
      { threshold: 0 }
    );
    observer.observe(this.atcWrap);
  };

  function productPath(el) {
    var link = el.querySelector('a[href*="/products/"]');
    if (!link) return '';
    try {
      return new URL(link.getAttribute('href'), window.location.origin).pathname;
    } catch (err) {
      return link.getAttribute('href') || '';
    }
  }

  function dedupeRelated() {
    var sections = qsa(document, '[data-wg-related]');
    if (sections.length < 2) return;
    var seen = {};
    sections.forEach(function (section, index) {
      var items = section.querySelectorAll('.wg-grid--products > li');
      var kept = 0;
      items.forEach(function (item) {
        var path = productPath(item);
        if (index > 0 && path && seen[path]) {
          item.remove();
          return;
        }
        if (path) seen[path] = true;
        kept += 1;
      });
      if (index > 0 && kept < 2) {
        var inner = section.querySelector('.wg-related__inner');
        if (inner) inner.remove();
      }
    });
  }

  function placePdpAccordions() {
    var accs = qs(document, '.wg-pdp-accs');
    var related = qs(document, '.template-product .shopify-section.wg-section-related');
    if (!accs || !related || !related.parentNode || accs.getAttribute('data-wg-moved') === '1') return;
    var host = document.createElement('div');
    host.className = 'wg-pdp-accs-host';
    var page = document.createElement('div');
    page.className = 'wg-page';
    host.appendChild(page);
    page.appendChild(accs);
    accs.setAttribute('data-wg-moved', '1');
    related.parentNode.insertBefore(host, related.nextSibling);
  }

  function loadRelated() {
    var nodes = qsa(document, '[data-wg-related]');
    var pending = nodes.length;
    if (!pending) return;
    var done = function () {
      pending -= 1;
      if (pending <= 0) {
        dedupeRelated();
        placePdpAccordions();
      }
    };
    nodes.forEach(function (el) {
      var url = el.getAttribute('data-url');
      var intent = el.getAttribute('data-wg-rec-intent');
      var hasFallback = el.querySelector('.wg-related__inner li');
      if (!url || (hasFallback && intent === 'complementary')) {
        done();
        return;
      }
      fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var inner = doc.querySelector('.wg-related__inner');
          if (inner && inner.querySelector('li')) {
            el.innerHTML = inner.outerHTML;
            el.setAttribute('data-wg-rec-method', 'recommendations');
          }
        })
        .catch(function () {})
        .then(done);
    });
  }

  function revealReviews() {
    var section = document.querySelector('[data-wg-reviews]');
    if (!section) return;
    var widget = section.querySelector('#seal-review-widget');
    var iframe = section.querySelector('iframe');
    var hasIframe = iframe && iframe.getAttribute('src');
    var hasReviews = false;
    if (widget) {
      var text = (widget.textContent || '').replace(/\s+/g, ' ').trim();
      hasReviews = widget.querySelector('.seal-review, .reviews, [class*="review-item"]') || text.length > 80;
    }
    if (hasIframe || hasReviews) {
      section.hidden = false;
    } else {
      section.hidden = true;
    }
  }

  ready(function () {
    qsa(document, '[data-wg-product]').forEach(function (el) {
      new WgPdp(el);
    });
    loadRelated();
    placePdpAccordions();
    revealReviews();
    var reviewRoot = document.querySelector('[data-wg-reviews]');
    if (reviewRoot && 'MutationObserver' in window) {
      var obs = new MutationObserver(revealReviews);
      obs.observe(reviewRoot, { childList: true, subtree: true });
      window.setTimeout(revealReviews, 2500);
      window.setTimeout(revealReviews, 6000);
    }
  });
})();
